import { INode } from 'shared/types/tree'
import { NodeType, QuestionType } from 'shared/types/ingestion'
import { getQuestionType } from '../../../utility/TreeHelpers'

export function childListsOfType(
  node: INode,
  listType: NodeType,
  childType: NodeType,
) {
  return node.nodes.filter((n) => {
    if (n.type !== listType) return false
    if (n.body?.type === childType) return true
    return n.nodes[0]?.type === childType
  })
}

export function getQuestionTargetLists(question: INode) {
  return childListsOfType(question, NodeType.Inline, NodeType.QuestionTarget)
}
export function getQuestionItemLists(question: INode) {
  return childListsOfType(question, NodeType.Inline, NodeType.QuestionItem)
}

export function getPlaceholderLists(question: INode) {
  let listType: NodeType | undefined
  const questionType = getQuestionType(question)
  switch (questionType) {
    case QuestionType.Placeholder:
      listType = NodeType.QuestionPlaceholder
      break
    case QuestionType.PlaceholderDnD:
      listType = NodeType.QuestionPlaceholderDnD
      break
  }
  if (!listType) return []
  return childListsOfType(question, NodeType.NodeList, listType)
}

export function getQuestionAnswerLists(question: INode) {
  return childListsOfType(question, NodeType.Inline, NodeType.QuestionAnswer)
}

const externalIdPattern = /[^{{}]+(?=}})/g

export function getPlaceholderTemplate(question: INode) {
  return question.body?.placeholder_value
}

export function getPlaceholderTemplateIds(
  question: INode,
): string[] | undefined {
  const template = getPlaceholderTemplate(question)
  if (!template) return
  return template.match(externalIdPattern) || []
}

export function getExternalId(node: INode) {
  return node.body?.ExternalID
}

export function getPlaceholderAnswerIds(question: INode) {
  const [firstList] = getPlaceholderLists(question)
  if (!firstList) return
  return firstList.nodes.map(getExternalId)
}

export function getTargetListExternalIds(targetList: INode) {
  return targetList.nodes.reduce((acc: string[], n) => {
    n.body?.ExternalID && acc.push(n.body.ExternalID)
    return acc
  }, [])
}

export function getItemListExternalIds(itemList: INode) {
  return itemList.nodes.reduce((acc: string[], n) => {
    acc.push(...(n.body?.targets || []))
    return acc
  }, [])
}

export function getOrderItemExternalIds(question: INode) {
  const [list] = childListsOfType(
    question,
    NodeType.Inline,
    NodeType.QuestionItem,
  )
  if (!list) return []
  return list.nodes.reduce((acc: string[], node) => {
    if (node.body?.ExternalID) {
      acc.push(node.body.ExternalID)
    }
    return acc
  }, [])
}
